import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=2c67a1f4"
import script from "./ReportsList.vue?vue&type=script&lang=js"
export * from "./ReportsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports